var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutgoing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4893 28.8672C37.7266 29.6299 37.7266 30.8662 38.4893 31.6289C39.252 32.3916 40.4883 32.3916 41.251 31.6289L46.499 26.3809C47.2676 25.6123 47.252 24.3721 46.499 23.6191L41.251 18.3711C40.4883 17.6084 39.252 17.6084 38.4893 18.3711C37.7266 19.1338 37.7266 20.3701 38.4893 21.1338L40.4033 23.0479H24.2236C23.1445 23.0479 22.2705 23.9219 22.2705 25.001C22.2705 26.0801 23.1445 26.9541 24.2236 26.9541H40.4033L38.4893 28.8672Z",
    fill: "#D83832"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.95312 50H33.7891C34.8682 50 35.7422 49.126 35.7422 48.0469V40.625C35.7422 39.5459 34.8682 38.6719 33.7891 38.6719C32.71 38.6719 31.8359 39.5459 31.8359 40.625V46.0938H3.90625V3.90625H31.8359V9.375C31.8359 10.4541 32.71 11.3281 33.7891 11.3281C34.8682 11.3281 35.7422 10.4541 35.7422 9.375V1.95312C35.7422 0.874023 34.8682 0 33.7891 0H1.95312C0.874023 0 0 0.874023 0 1.95312V48.0469C0 49.126 0.874023 50 1.95312 50Z",
    fill: "#0E3368"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutgoing);
export default __webpack_public_path__ + "static/media/outgoing.7ac57e72.svg";
export { ForwardRef as ReactComponent };